export const GET_RULES_REQUEST = 'GET_RULES_REQUEST';
export const GET_RULES_FAILURE = 'GET_RULES_FAILURE';
export const GET_RULES_SUCCESS = 'GET_RULES_SUCCESS';

export const CREATE_RULE_REQUEST = 'CREATE_RULE_REQUEST';
export const CREATE_RULE_FAILURE = 'CREATE_RULE_FAILURE';
export const CREATE_RULE_SUCCESS = 'CREATE_RULE_SUCCESS';

export const GET_RULE_REQUEST = 'GET_RULE_REQUEST';
export const GET_RULE_FAILURE = 'GET_RULE_FAILURE';
export const GET_RULE_SUCCESS = 'GET_RULE_SUCCESS';

export const UPDATE_RULE_REQUEST = 'UPDATE_RULE_REQUEST';
export const UPDATE_RULE_FAILURE = 'UPDATE_RULE_FAILURE';
export const UPDATE_RULE_SUCCESS = 'UPDATE_RULE_SUCCESS';

export const DELETE_RULE_REQUEST = 'DELETE_RULE_REQUEST';
export const DELETE_RULE_FAILURE = 'DELETE_RULE_FAILURE';
export const DELETE_RULE_SUCCESS = 'DELETE_RULE_SUCCESS';

export const GET_RULE_FIELDS_REQUEST = 'GET_RULE_FIELDS_REQUEST';
export const GET_RULE_FIELDS_FAILURE = 'GET_RULE_FIELDS_FAILURE';
export const GET_RULE_FIELDS_SUCCESS = 'GET_RULE_FIELDS_SUCCESS';

export const SET_RULE_TITLE = 'SET_RULE_TITLE';
export const SET_RULE_EVENT = 'SET_RULE_EVENT';
export const ADD_RULE_CONDITION = 'ADD_RULE_CONDITION';
export const REMOVE_RULE_CONDITION = 'REMOVE_RULE_CONDITION';
export const SET_RULE_CONDITION = 'SET_RULE_CONDITION';
export const ADD_RULE_ACTION = 'ADD_RULE_ACTION';
export const REMOVE_RULE_ACTION = 'REMOVE_RULE_ACTION';
export const SET_RULE_ACTION = 'SET_RULE_ACTION';



// WEBPACK FOOTER //
// ./src/store/modules/rules/mutation-types.js